export default __webpack_public_path__ + "static/media/delete_icon.b248a0b6.svg";